import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useGetAccountingBanksListWithSpreadFilter } from "../../../../hooks/api/queries";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import { useCheckoutHelper } from "../../../../hooks/useCheckoutHelper";

export const LedgerForm = () => {
  const { isLoading: isLoadingBankAccountsList, data: bankAccounts } =
    useGetAccountingBanksListWithSpreadFilter({
      account_type: "bank_account",
    });
  const { ledger_account_id, setLedgerAccount } = useCheckoutHelper();

  return (
    <div
      className={`${globalStyles.cardWithBorder} flex-row align-items-center`}
      style={{ columnGap: "30px" }}
    >
      <h6 className="font-weight-nomal">Accounting</h6>

      <div className="w-100">
        <secondaryComponents.LoaderHelper
          isLoading={isLoadingBankAccountsList}
          className="mt-1"
        >
          <primaryComponents.SelectField
            placeholder={"Select Account"}
            options={bankAccounts?.data?.map((bank) => ({
              id: bank?.id,
              name: bank?.account_name,
            }))}
            idKey="id"
            nameKey="name"
            value={
              bankAccounts?.data?.find(
                (bankAccount) =>
                  `${bankAccount?.id}` === `${ledger_account_id}`,
              )?.account_name || "Select account"
            }
            onChange={(value) => {
              setLedgerAccount(value);
            }}
            floatError={false}
            classNames="bank-name"
          />
        </secondaryComponents.LoaderHelper>
      </div>
    </div>
  );
};
